// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  staging: 'dev',
  firebaseConfig : {
    apiKey: 'AIzaSyBc6hNP5ryw3YSRWwQrfGOE2aGOSS8yMcM',
    authDomain: 'parkix-1f8c3.firebaseapp.com',
    projectId: 'parkix-1f8c3',
    storageBucket: 'parkix-1f8c3.appspot.com',
    messagingSenderId: '811163197180',
    appId: '1:811163197180:web:9b1fd4414fce4f2ef50179'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
